@if (isAdmin()) {
  <nz-tabset>
    <nz-tab nzTitle="Update Trial">
      <div class="tab-content">
        <div class="vertical">
          <div class="horizontal text-input">
            <input [(ngModel)]="email" nz-input placeholder="Email" nzSize="large" />
            <button nz-button nzType="default" nzSize="large" (click)="onWorkspaceListClick()">
              Get Workspace List
            </button>
          </div>

          <nz-radio-group [(ngModel)]="currentWorkspace" (ngModelChange)="onWorkspaceChange($event)">
            @for (workspace of workspaceList(); track $index) {
              <label nz-radio [nzValue]="workspace">{{ workspace.title }}</label>
            }
          </nz-radio-group>

          @if (currentWorkspace) {
            <div class="basic-card-color blue-background margin-top vertical">
              <nz-segmented [nzOptions]="trialTypeOptions" [(ngModel)]="trialIndex" class="fit-content"></nz-segmented>

              <app-date-time-selector [(time)]="newExpiredTime"></app-date-time-selector>

              <input [(ngModel)]="subscriptionId" nz-input placeholder="New Subscription Id" nzSize="large" />

              <button
                class="fit-content"
                nz-button
                nzType="default"
                nzSize="default"
                (click)="onSaveWorkspaceDetailClick()"
              >
                Save
              </button>
            </div>
          }
        </div>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Recording List">
      <div class="tab-content vertical">
        <div class="vertical-large">
          <div class="horizontal text-input">
            <input [(ngModel)]="userId" nz-input placeholder="User Id" nzSize="large" />
            <button nz-button nzType="default" nzSize="large" (click)="onGetRecordinglistClick()">Run</button>
          </div>

          <div class="vertical-large">
            @for (session of sessionList(); track $index) {
              <div class="basic-block vertical">
                <video controls class="video-player">
                  <source [src]="session.subData.recordingUrl" type="video/webm" />
                  Your browser does not support the video tag.
                </video>

                <div>{{ getLocalTime(session.createdTimeStr) }}</div>
              </div>
            }
          </div>
        </div>
      </div>
    </nz-tab>
  </nz-tabset>
} @else {
  <h3>Loading...</h3>
}
